<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> اجاره&zwnj;های فعال </span>

    </div>

</div>

<main style="direction: rtl;" class="py-2 px-2">

    <div class="border border-2 mt-1 p-2">

        <div class="row gx-0 gy-2">

            <!-- فیلتر جستجو -->

            <div class="col-md-11 col-12">

                <input type="text" class="w-100 form-control"
        
                    placeholder=" بر اساس شماره دستگاه, نام و نام خانوادگی, شماره موبایل جستجو کنید ..."
                    
                    (keyup)="filter_list($event.target)">

            </div>

            <!-- افزودن -->

            <div class="col-md-auto col-12 p-1">

                <button class="w-100 btn btn-success" (click)="openNewRent_Modal()">
                    
                    &nbsp; افزودن &nbsp; 
                
                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 130px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>
    
                        <th class="text-center"> شماره دستگاه </th>

                        <th class="text-center"> شماره اجاره </th>
            
                        <th class="text-center"> تاریخ اجاره </th>

                        <th class="text-center"> ساعت اجاره </th>

                        <th class="text-center"> نام نام خانوادگی </th>

                        <th class="text-center"> موبایل </th>
        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_ActiveRent;let i = index">

                        <th> {{ i + 1 | faNum }} </th>
                            
                        <th class="f18">

                            <i class="bg-i rounded pointer fa fa-map-marker" (click)="showOnMap(item)" title="موقعیت"></i>
                        
                            <i class="bg-i rounded pointer fa fa-info-circle text-success mx-2" (click)="showReport(item)" title="گزارش"></i>

                            <i class="bg-i px-2 rounded pointer" title="تحویل" (click)="showDeliver(item)">

                                <img width="23px" height="23px" src="../../../assets/Img/delivery.png" alt="تحویل">

                            </i>
                            
                            
                        
                        </th>

                        <td> {{ item.iCode | faNum }} </td>

                        <td> {{ item.iRent | faNum }} </td>

                        <td> {{ item.strRent_Date | faNum }} </td>

                        <td> {{ item.strRent_Time | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strMobile | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- گزارش -->

<div class="modal fade" id="RentInfo_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> گزارش </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="container-fluid row gx-2 gy-2 p-2">

                    <!-- شماره اجاره -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> شماره اجاره </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.iRent | faNum" disabled>
            
                    </div>

                    <!-- مدت اجاره تا کنون -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> مدت اجاره تا کنون </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.strRentTime | faNum" disabled>
            
                    </div>

                    <!-- مسافت -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> مسافت </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.fKm + ' کیلومتر ' | faNum" disabled>
            
                    </div>

                    <!-- هزینه تا کنون -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> هزینه تا کنون </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.iCost?.toLocaleString() + ' ریال ' | faNum" disabled>
            
                    </div>
                    
                    <!-- حداکثر سرعت -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> حداکثر سرعت </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.iMaxSpeed + ' کیلومتر ' | faNum" disabled>
            
                    </div>
                    
                    <!-- تخلف خروج غیر مجاز -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تخلف خروج غیر مجاز </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.bOutofDomainError == false ? 'خیر' : 'بله' " disabled>
            
                    </div>
                    
                    <!-- تصادف -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تصادف </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentInfo.bAccident == false ? 'خیر' : 'بله' " disabled>
            
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- مسیر -->

                <button class="btn btn-primary px-3" (click)="showRoute(obj_RentRoute)">

                    &nbsp; مسیر &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- تحویل -->

<div class="modal fade" id="RentAnalysis_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> تحویل </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="container-fluid row gx-2 gy-2 p-2">

                    <!-- شماره اجاره -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> شماره اجاره </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iRent | faNum" disabled>
            
                    </div>

                    <!-- نام و نام‌خانوادگی -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> نام و نام&zwnj;خانوادگی </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strFullName | faNum" disabled>
            
                    </div>

                    <!-- موبایل -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> موبایل </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strMobile | faNum" disabled>
            
                    </div>

                    <!-- کد ملی -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> کد ملی </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strID | faNum" disabled>
            
                    </div>
                    
                    <!-- نوع وثیقه -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> نوع وثیقه </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_CollateralType_strComment | faNum" disabled>
            
                    </div>

                    <!-- تاریخ اجاره  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ اجاره  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_Date | faNum" disabled>
            
                    </div>

                    <!-- ساعت اجاره  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> ساعت اجاره  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_Time | faNum" disabled>
            
                    </div>

                    <!-- تاریخ پایان  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ پایان  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strReturn_Date | faNum" disabled>
            
                    </div>

                    <!-- ساعت پایان  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> ساعت پایان  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strReturn_Time | faNum" disabled>
            
                    </div>
                                        
                    <!-- مدت اجاره تا کنون -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> مدت اجاره تا کنون </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRentTime | faNum" disabled>
            
                    </div>
                    
                    <!-- هزینه اجاره -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> هزینه اجاره </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iCost?.toLocaleString() + ' ریال ' | faNum" disabled>
            
                    </div>
                    
                    <!-- پیمایش -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> پیمایش </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.fKm + ' کیلومتر ' | faNum" disabled>
            
                    </div>
                             
                    <!-- حداکثر سرعت -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> حداکثر سرعت </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iMaxSpeed + ' کیلومتر ' | faNum" disabled>
            
                    </div>
                                        
                    <!-- تخلف خروج غیر مجاز -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تخلف خروج غیر مجاز </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.bOutofDomainError == false ? 'خیر' : 'بله' " disabled>
            
                    </div>
                                        
                    <!-- تصادف -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تصادف </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.bAccident == false ? 'خیر' : 'بله' " disabled>
            
                    </div>

                    <!--  -->

                    <hr class="my-3">

                    <!-- خسارت -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bDamage" [(ngModel)]="obj_RentAnalysis.bDamage">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bDamage"> دستگاه خسارت دیده است </label>
                    
                    </div>

                    <!-- اگر خسارت انتخاب شده بود -->

                    <ng-container *ngIf="obj_RentAnalysis.bDamage">

                        <!-- هزینه خسارت (ریال) -->

                        <div class="position-relative col-12 col-md-5 p-2">
                
                            <label class="mb-2 text-muted"> هزینه خسارت (ریال) </label>
                
                            <input class="form-control p-2 text-center" 

                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                    
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                
                                [(ngModel)]="obj_RentAnalysis.iDamageCost">
                
                        </div>


                    </ng-container>

                    <!-- توضیحات -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="height: 100px;resize: none;" class="form-control" [(ngModel)]="obj_RentAnalysis.strComment"></textarea>

                    </div>
                    
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- مسیر -->

                <button class="btn btn-primary px-3" (click)="showRoute(obj_RentAnalysis)">

                    &nbsp; مسیر &nbsp;

                </button>

                <!-- پایان -->

                <button class="btn btn-outline-danger px-3" (click)="endDelivery()">

                    &nbsp; پایان &nbsp;

                </button>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- افزودن -->

<div class="modal fade" id="Rent_Modal" tabindex="-1"  aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> افزودن </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_Rent" class="container-fluid row gx-2 gy-2 p-2">

                    <!-- بررسی شماره یا کد ملی -->

                    <ng-container *ngIf="mdl_Rent.get('iRentCount')?.value.toString() == '' ">

                        <!-- کد ملی -->

                        <div class="position-relative col-12 col-md-6 p-2">
                
                            <label class="mb-2 text-muted"> کد ملی </label>
                
                            <input class="form-control p-2 text-center" 

                                maxlength="10"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                            
                                formControlName="strID">
                
                        </div>

                        <!-- شماره موبایل -->

                        <div class="position-relative col-12 col-md-6 p-2">
                
                            <label class="mb-2 text-muted"> شماره موبایل </label>
                
                            <input class="form-control p-2 text-center"

                                maxlength="11"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                            
                                formControlName="strMobile">
                
                        </div>

                    </ng-container>

                    <!-- افزودن اطلاعات -->

                    <ng-container *ngIf="mdl_Rent.get('iRentCount')?.value.toString() != '' ">

                        <!-- تعداد اجاره -->

                        <div class="position-relative col-12 col-md-6 p-2">
                
                            <label class="mb-2 text-muted"> تعداد اجاره </label>
                
                            <input class="form-control p-2 text-center"  formControlName="iRentCount">
                
                        </div>

                        <!-- تعداد تخلف -->

                        <div class="position-relative col-12 col-md-6 p-2">
                
                            <label class="mb-2 text-muted"> تعداد تخلف </label>
                
                            <input class="form-control p-2 text-center"  formControlName="iRentDamage">
                
                        </div>

                        <!-- کد ملی -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> * کد ملی </label>
                
                            <input class="form-control p-2 text-center" 

                                maxlength="10"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                            
                                formControlName="strID">
                
                        </div>

                        <!-- نام و نام خانوادگی -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام و نام خانوادگی </label>
                
                            <input class="form-control p-2 text-center" formControlName="strFullName">
                
                        </div>
                        
                        <!--  موبایل -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted">  * موبایل </label>
                
                            <input class="form-control p-2 text-center"

                                maxlength="11"

                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                            
                                formControlName="strMobile">
                
                        </div>

                        <!-- نام دستگاه -->

                        <div class="col-12 col-md-4 position-relative p-2">

                            <label class="mb-2 text-muted"> * نام دستگاه </label>

                            <select class="form-select p-2 text-center" formControlName="iCode">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Vehicle" [value]="item.iCode">

                                    {{item.strFullName}}

                                </option>

                            </select>

                        </div>
                        
                        <!-- نوع وثیقه -->

                        <div class="col-12 col-md-4 position-relative p-2">

                            <label class="mb-2 text-muted"> * نوع وثیقه </label>

                            <select class="form-select p-2 text-center" formControlName="tiRent_CollateralType">

                                <option class="text-center" value=""> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Collateral" [value]="item.tiRent_CollateralType">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>
          
                        <!-- هزینه (ریال) -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> هزینه (ریال) </label>
                
                            <input class="form-control p-2 text-center"
                                                    
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString()
                                
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')"

                                formControlName="iCost">
                
                        </div>

                        <!-- توضیحات -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted"> توضیحات </label>

                            <textarea class="form-control" formControlName="strComment"></textarea>

                        </div>

                    </ng-container>
                    
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <!-- ذخیره -->

                <ng-container *ngIf="mdl_Rent.get('iRentCount')?.value.toString() != '';else isReview">

                    <button class="btn btn-success" (click)="save_NewRent()">

                        &nbsp; ثبت &nbsp;

                    </button>

                </ng-container>

                <!-- بررسی -->

                <ng-template #isReview>

                    <button class="btn btn-primary" (click)="checkOut_Rent()">

                        &nbsp; بررسی &nbsp;

                    </button>

                </ng-template>

                <!-- بستن -->

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>